import { Component, OnInit } from '@angular/core';
import { ContextService } from '../../services/context.service';
import { ApiService } from '../../services/api.service';
import { PeProviderService } from '../../services/pe-provider.service';
import { SelectItem } from 'primeng/primeng';
import { DataType, RowDataType } from '../../services/data.service.types';

@Component({
  selector: 'app-places',
  templateUrl: './places.component.html',
  styleUrls: ['./places.component.css']
})
export class PlacesComponent implements OnInit {


  propertyTree = [
    {
      group: 'astiko', groupLabel: 'Αστικό'
      , nameLabel: ['Βόθροι', 'Φρεάτια', 'Πηγάδια', 'Λοιπές Υδατοσυλλογές'],
      name: ['vothroi', 'freatia', 'pigadia', 'loipes_ydatosylloges']
    },
    {
      group: 'agrotiko', groupLabel: 'Αγροτικό'
      , nameLabel: ['Κανάλια', 'Ρέματα', 'Πηγάδια', 'Λοιπές Υδατοσυλλογές']
      , name: ['kanalia', 'remata', 'pigadia', 'loipes_ydatosylloges']
    },
    {
      group: 'fysiko_systima', groupLabel: 'Φυσικό σύστημα'
      , nameLabel: ['Πλημμυρισμένες εκτάσεις']
      , name: ['plimirismenes_ektaseis']
    }
  ];

  private pes: { name: string, code: number }[] = [];
  private dimoi: { grname: string, hlpcode: number, extent: [number, number, number, number] }[] = [];
  private oikismoi: { name: string }[] = [];
  private data: (RowDataType & { name: string, year: number, month: number })[] = [];
  private editData: (RowDataType & { name: string, year: number, month: number })[] = [];
  private displayDialog: boolean;
  private selectedRow: (RowDataType & { name: string, year: number, month: number });
  private newRow: boolean;
  constructor(private app: ContextService, private peProvider: PeProviderService, private api: ApiService) {
    app.places = this;
  }

  async ngOnInit() {
    const pe = await this.peProvider.data;
    this.pes = pe;
  }

  async peChanged(e: { value: { name: string, code: number } }) {
    this.selectedRow = undefined;
    const pe = e.value;
    const code = pe.code;

    const dimoi = await this.api.get('/herrco/dimos/nomou/' + code);
    this.dimoi = dimoi;
    this.oikismoi = [];
    this.data = [];
    this.editData = [];
  }

  async dimosChanged(e: { value: { grname: string, hlpcode: number, extent: [number, number, number, number] } }) {
    this.selectedRow = undefined;
    const d = e.value;
    const data: DataType[] = await this.api.get('/kounoupia/data/' + d.hlpcode);
    const tmpData: (RowDataType & { name: string, year: number, month: number })[] = [];

    this.oikismoi = data.map(di => (di.oikismos)).filter((v, i, r) => r.indexOf(v) === i).map(v => ({ name: v }));
    this.editData = [];
    data.forEach(m => {
      Object.keys(m.month).forEach(k => {
        const dt = m.month[k];
        dt.year = m.year;
        dt.name = m.oikismos;
        dt.month = k;
        tmpData.push(dt);
      });
    });
    this.data = tmpData;
  }

  oikismosChanged(e: { value: { name: string } }) {
    this.selectedRow = undefined;
    this.editData = this.data.filter(d => d.name === e.value.name);
  }



  onRowSelect(e: { data: (RowDataType & { name: string, year: number, month: number }) }) {
    this.newRow = false;
    // this.car = this.cloneCar(event.data);
    // this.displayDialog = true;
    console.log(e.data);
    this.selectedRow = e.data;
    this.displayDialog = true;
  }



  showDialogToAdd() {
    this.newRow = true;
    this.selectedRow = {
      year: 2017,
      month: 0,
      astiko: {
        freatia: 0,
        loipes_ydatosylloges: 0,
        pigadia: 0,
        vothroi: 0
      },
      agrotiko: {
        kanalia: 0,
        loipes_ydatosylloges: 0,
        pigadia: 0,
        remata: 0
      },
      fysiko_systima: {
        plimirismenes_ektaseis: 0
      },
      name: this.editData[0].name
    };

    this.displayDialog = true;
  }

  save() {
    const [index_in_edit_data, index_in_data] = this.findSelectedCarIndex();
    const editData = [...this.editData];
    if (this.newRow) {
      editData.push(this.selectedRow);
    } else {
      editData[index_in_edit_data] = this.selectedRow;
    }

    // this.newRow = false;
    this.editData = editData;
    // this.selectedRow = null;
    this.displayDialog = false;
  }

  delete() {
    if (!this.newRow) {
      const [index_in_edit_data, index_in_data] = this.findSelectedCarIndex();
      this.editData = this.editData.filter((val, i) => i !== index_in_edit_data);
      this.data = this.data.filter((val, i) => i !== index_in_data);
    }
    // this.newRow = false;
    this.selectedRow = null;
    this.displayDialog = false;
  }

  findSelectedCarIndex(): [number, number] {
    return [
      this.editData.findIndex(d => d.year === this.selectedRow.year && d.month === this.selectedRow.month),
      this.data.findIndex(d => d.year === this.selectedRow.year && d.month === this.selectedRow.month)
    ];
  }

}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-data-entry/src/app/components/places/places.component.ts